"use strict";

var _classCallCheck = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // @ts-ignore: Could not find a declaration file for module

var inspector = require("schema-inspector");

var profile_1 = require("../profile");

var profileTokens_1 = require("../profileTokens");

var personLegacy_1 = require("./personLegacy");

var personUtils_1 = require("./personUtils");

var schemaDefinition = {
  type: 'object',
  strict: false,
  properties: {
    '@context': {
      type: 'string',
      optional: true
    },
    '@type': {
      type: 'string'
    },
    '@id': {
      type: 'string',
      optional: true
    },
    name: {
      type: 'string',
      optional: true
    },
    givenName: {
      type: 'string',
      optional: true
    },
    familyName: {
      type: 'string',
      optional: true
    },
    description: {
      type: 'string',
      optional: true
    },
    image: {
      type: 'array',
      optional: true,
      items: {
        type: 'object',
        properties: {
          '@type': {
            type: 'string'
          },
          name: {
            type: 'string',
            optional: true
          },
          contentUrl: {
            type: 'string',
            optional: true
          }
        }
      }
    },
    website: {
      type: 'array',
      optional: true,
      items: {
        type: 'object',
        properties: {
          '@type': {
            type: 'string'
          },
          url: {
            type: 'string',
            optional: true
          }
        }
      }
    },
    account: {
      type: 'array',
      optional: true,
      items: {
        type: 'object',
        properties: {
          '@type': {
            type: 'string'
          },
          service: {
            type: 'string',
            optional: true
          },
          identifier: {
            type: 'string',
            optional: true
          },
          proofType: {
            type: 'string',
            optional: true
          },
          proofUrl: {
            type: 'string',
            optional: true
          },
          proofMessage: {
            type: 'string',
            optional: true
          },
          proofSignature: {
            type: 'string',
            optional: true
          }
        }
      }
    },
    worksFor: {
      type: 'array',
      optional: true,
      items: {
        type: 'object',
        properties: {
          '@type': {
            type: 'string'
          },
          '@id': {
            type: 'string',
            optional: true
          }
        }
      }
    },
    knows: {
      type: 'array',
      optional: true,
      items: {
        type: 'object',
        properties: {
          '@type': {
            type: 'string'
          },
          '@id': {
            type: 'string',
            optional: true
          }
        }
      }
    },
    address: {
      type: 'object',
      optional: true,
      properties: {
        '@type': {
          type: 'string'
        },
        streetAddress: {
          type: 'string',
          optional: true
        },
        addressLocality: {
          type: 'string',
          optional: true
        },
        postalCode: {
          type: 'string',
          optional: true
        },
        addressCountry: {
          type: 'string',
          optional: true
        }
      }
    },
    birthDate: {
      type: 'string',
      optional: true
    },
    taxID: {
      type: 'string',
      optional: true
    }
  }
};
/**
 * @ignore
 */

var Person =
/*#__PURE__*/
function (_profile_1$Profile) {
  _inherits(Person, _profile_1$Profile);

  function Person() {
    var _this;

    var profile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Person);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Person).call(this, profile));
    _this._profile = Object.assign({}, {
      '@type': 'Person'
    }, _this._profile);
    return _this;
  }

  _createClass(Person, [{
    key: "toJSON",
    value: function toJSON() {
      return {
        profile: this.profile(),
        name: this.name(),
        givenName: this.givenName(),
        familyName: this.familyName(),
        description: this.description(),
        avatarUrl: this.avatarUrl(),
        verifiedAccounts: this.verifiedAccounts(),
        address: this.address(),
        birthDate: this.birthDate(),
        connections: this.connections(),
        organizations: this.organizations()
      };
    }
  }, {
    key: "profile",
    value: function profile() {
      return Object.assign({}, this._profile);
    }
  }, {
    key: "name",
    value: function name() {
      return personUtils_1.getName(this.profile());
    }
  }, {
    key: "givenName",
    value: function givenName() {
      return personUtils_1.getGivenName(this.profile());
    }
  }, {
    key: "familyName",
    value: function familyName() {
      return personUtils_1.getFamilyName(this.profile());
    }
  }, {
    key: "description",
    value: function description() {
      return personUtils_1.getDescription(this.profile());
    }
  }, {
    key: "avatarUrl",
    value: function avatarUrl() {
      return personUtils_1.getAvatarUrl(this.profile());
    }
  }, {
    key: "verifiedAccounts",
    value: function verifiedAccounts(verifications) {
      return personUtils_1.getVerifiedAccounts(this.profile(), verifications);
    }
  }, {
    key: "address",
    value: function address() {
      return personUtils_1.getAddress(this.profile());
    }
  }, {
    key: "birthDate",
    value: function birthDate() {
      return personUtils_1.getBirthDate(this.profile());
    }
  }, {
    key: "connections",
    value: function connections() {
      return personUtils_1.getConnections(this.profile());
    }
  }, {
    key: "organizations",
    value: function organizations() {
      return personUtils_1.getOrganizations(this.profile());
    }
  }], [{
    key: "validateSchema",
    value: function validateSchema(profile) {
      var strict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      schemaDefinition.strict = strict;
      return inspector.validate(schemaDefinition, profile);
    }
  }, {
    key: "fromToken",
    value: function fromToken(token) {
      var publicKeyOrAddress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var profile = profileTokens_1.extractProfile(token, publicKeyOrAddress);
      return new Person(profile);
    }
  }, {
    key: "fromLegacyFormat",
    value: function fromLegacyFormat(legacyProfile) {
      var profile = personLegacy_1.getPersonFromLegacyFormat(legacyProfile);
      return new Person(profile);
    }
  }]);

  return Person;
}(profile_1.Profile);

exports.Person = Person;